import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles((theme) => ({
  table: {
    minWidth: 1050,
    marginBottom: '20px',
    maxHeight: '165px',
    overflowY: 'auto',
    tableLayout: 'fixed',
  },
  tableContainer: {
    overflowX: 'hidden',
  },
  tableHead: {
    backgroundColor: 'rgb(245, 250, 235)',
    borderBottom: 'hidden',
  },
  tableRow: {
    borderBottom: '2px solid #e6e7e6',
  },
  portalContent: {
    padding: '16px 20px 0px 20px',
    display: 'block',
    // overflow: 'auto',
  },
  cellTitle: {
    padding: '5px 20px 5px 20px',
    color: 'rgb(85, 130, 50)',
    fontSize: '15px',
    borderBottom: 'none',
  },
  cellName: {
    verticalAlign: 'top',
    padding: '10px 30px 5px 0px',
    borderBottomColor: 'rgb(191, 191, 191)',
  },
  cellDate: {
    padding: '10px 0px 5px 15px',
    verticalAlign: 'top',
    color: 'rgb(59, 56, 56)',
    fontSize: '13px',
    borderBottomColor: 'rgb(191, 191, 191)',
  },
  cellLinkDate: {
    padding: '10px 0px 5px 15px',
    verticalAlign: 'top',
    color: 'rgb(59, 56, 56)',
    fontSize: '13px',
    borderBottomColor: 'rgb(191, 191, 191)',
  },
  cellContent: {
    padding: '10px 10px 5px 0px',
    fontWeight: 'bold',
    color: 'rgb(59, 56, 56)',
    borderBottomColor: 'rgb(191, 191, 191)',
    verticalAlign: 'top',
  },

  cellContentBackground: {
    display: 'flex',
    flexDirection: 'column',
  },
  cellContentTitle: {
    fontSize: '13px',
    lineBreak: 'anywhere',
    fontWeight: 'bold',
    width: '450px',
    paddingRight: '10px',
  },
  cellContentMessage: {
    // width: '1366px !important',
    fontWeight: 'normal',
    fontSize: '12px',
    paddingTop: '10px',
    paddingLeft: '15px',
    wordWrap: 'normal',
    whiteSpace: 'break-spaces',
    wordBreak: 'break-word',
    width: 'calc(100%)',
  },
  personTitle: {
    fontWeight: 'bold',
    color: 'rgb(59, 56, 56)',
    fontSize: '12px',
  },
  personName: {
    color: 'rgb(59, 56, 56)',
    fontSize: '12px',
    fontWeight: 'normal',
  },
  fileAttachWrapper: {
    margin: '10px 0 0 12px',
    // width: '1366px !important',
    width: 'calc(100%)',
    minWidth: '100%',
  },
  fileAttachContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    marginRight: '30px',
    height: '20px',
  },
  fileAttachItem: {
    marginRight: '5px',
  },
  link: {
    left: '1.2rem',
    top: '60%',
    color: '#5e7bae',
    fontSize: '12px',
    fontWeight: 'normal',
  },
  fileIcon: {
    // left: '-0.5rem',
  },
  url: {
    color: '#5e7bae',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 'normal',
  },
  firstCol: {
    width: '144px !important',
  },
  secondCol: {
    width: '450px !important',
  },
  thirdCol: {},

  customCellNoPading: {
    padding: '0px',
    margin: '0px',
  },
  titleBlock1: {
    display: 'flex',
    direction: 'column',
    padding: '10px 0px 5px 0',
  },
  childTitleBlock1: {
    display: 'block',
  },
  cellNoticeContentMessage: {
    fontWeight: 'normal',
    fontSize: '12px',
    paddingTop: '5px',
    paddingLeft: '15px',
    wordWrap: 'normal',
    whiteSpace: 'break-spaces',
    wordBreak: 'break-word',
    width: 'calc(100%)',
    paddingBottom: '5px',
  },
  childBlock1: {
    fontSize: '13px',
  },
  childTitleBlock2: {
    fontSize: '13px',
    lineBreak: 'anywhere',
  },
  childBlock2: {
    fontSize: '13px',
    width: 'calc(55% - 30px)',
    padding: 0,
    margin: 0,
  },
  '@media (max-width: 1855px)': {
    fileAttachWrapper: {
      width: '1250px !important',
    },
    cellContentMessage: {
      width: 'calc(100%)',
    },
  },
  '@media (max-width: 1755px)': {
    cellContentMessage: {
      width: '1000px !important',
    },
    fileAttachWrapper: {
      width: '1000px !important',
    },
    // firstCol: {
    //   width: '15%',
    // },
    // secondCol: {
    //   width: '38%',
    // },
    // thirdCol: {
    //   width: '47%',
    // },
  },
  '@media (max-width: 1500px)': {
    cellContentMessage: {
      width: '985px !important',
    },
    // cellNoticeContentMessage: {
    //   width: '900px !important',
    // },

    fileAttachWrapper: {
      width: '985px !important',
    },
  },
  // '@media (max-width: 1400px)': {
  //   cellTopicContentMessage: {
  //     width: '900px',
  //   },
  //   cellContentMessage: {
  //     width: '900px !important',
  //   },
  // },
}))

export default styles
